module.exports = __webpack_public_path__ + "img/white.2c95144.svg";